// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__toGHh","content":"Modal_content__pVIPe","visible":"Modal_visible__FEL5I","close":"Modal_close__iiR4h"};